import React, { useState } from 'react';
import { 
  List, ListItem, ListItemButton, ListItemIcon, ListItemText, 
  Divider, Typography, Box, Dialog, DialogTitle, DialogContent, 
  DialogContentText, DialogActions, Button, useMediaQuery 
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { 
  Dashboard, Fingerprint, EventNote, Description, 
  Assignment, AccountCircle, Logout, 
  Category,
  ManageAccounts
} from '@mui/icons-material';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useEssAppData } from '../../context/AppESSDataContext';

const ESSNavigation = () => {
  const theme = useTheme();
  const { authUser, logout } = useAuth();
  const navigate = useNavigate();
  const [openLogout, setOpenLogout] = useState(false);
  const {projectList,teamList} = useEssAppData();
  
  // Detect if we are on mobile to add the necessary top spacing
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const menuItems = [
    { text: 'Dashboard', icon: <Dashboard />, path: '/' },
    { text: 'Punch Log', icon: <Fingerprint />, path: '/attendance' },
    { text: 'Leave Request', icon: <EventNote />, path: '/leave-request' },
    { text: 'Wrok Reports', icon: <Description />, path: '/work-report' },
    { text: 'Manage Tasks', icon: <Assignment />, path: '/task' },
  ];

  if(projectList && projectList.length > 0){
    menuItems.push({ text: 'My Projects', icon: <Category />, path: '/projects' })
  }

  if(teamList && teamList.length > 0){
    menuItems.push({ text: 'My Team', icon: <ManageAccounts />, path: '/team' })
  }

  return (
    <Box sx={{ 
        height: '90%', // Changed from 90% to 100% for better flex behavior
        display: 'flex', 
        flexDirection: 'column' 
    }}>
      {/* FIX: Add a spacer for Mobile view 
         This pushes the "Hello" header down so it isn't hidden under the navbar 
      */}
      {isMobile && <Box sx={{ height: '60px' }} />}

      {/* 1. Header Section */}
      <Box sx={{ p: 3, textAlign: 'center', bgcolor: 'primary.main', color: 'white' }}>
        <Typography variant="h6" noWrap sx={{ fontWeight: 'bold' }}>
          Hello, {authUser?.firstName || 'User'} 👋
        </Typography>
      </Box>

      {/* 2. Main Links */}
      <List sx={{ flexGrow: 1, px: 1 }}>
        {menuItems.map((item) => (
          <ListItem 
            key={item.text} 
            disablePadding 
            component={NavLink} 
            to={item.path} 
            style={({ isActive }) => ({
              textDecoration: 'none',
              color: isActive ? theme.palette.primary.main : 'inherit',
              backgroundColor: isActive ? '#f0f7ff' : 'transparent',
              display: 'block',
              borderRadius: '8px',
              marginBottom: '4px'
            })}
          >
            <ListItemButton sx={{ borderRadius: '8px' }}>
              <ListItemIcon sx={{ color: 'inherit', minWidth: '40px' }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      <Divider />

      {/* 3. Bottom Links */}
      <Box sx={{ pb: isMobile ? 4 : 2 }}> {/* Extra padding at bottom for mobile thumbs */}
        <List sx={{ px: 1 }}>
            {/*
            <ListItem disablePadding component={NavLink} to="/profile" style={{ textDecoration: 'none', color: 'inherit' }}>
            <ListItemButton sx={{ borderRadius: '8px' }}>
                <ListItemIcon sx={{ minWidth: '40px' }}><AccountCircle /></ListItemIcon>
                <ListItemText primary="Profile Page" />
            </ListItemButton>
            </ListItem>
            */}
            <ListItem disablePadding>
            <ListItemButton onClick={() => setOpenLogout(true)} sx={{ color: 'error.main', borderRadius: '8px' }}>
                <ListItemIcon sx={{ color: 'error.main', minWidth: '40px' }}><Logout /></ListItemIcon>
                <ListItemText primary="Logout" />
            </ListItemButton>
            </ListItem>
        </List>
      </Box>

      {/* Logout Dialog */}
      <Dialog open={openLogout} onClose={() => setOpenLogout(false)}>
        <DialogTitle>Confirm Logout</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to log out?</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setOpenLogout(false)} color="inherit">Cancel</Button>
          <Button onClick={() => { navigate('/auth/logout'); }} variant="contained" color="error">
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ESSNavigation;